export const CONTACT_US_URL = '/contact-us';
export const RETAIL_URL = '/compare-energy-rates-2';
export const LIGHTING_RETROFIT_URL = '/lighting-retrofit';
export const EV_CHARGING_URL = '/evcharging';
